import { filterAssetsNeedingShopifyPrepare } from './needsShopifyPrepareFormat';
import openAssetsCopyForShopifyPrepare from './openAssetsCopyForShopifyPrepare';
import showPrepareMediaForShopifyDialog from '../../components/PrepareMediaForShopifyDialog/showPrepareMediaForShopifyDialog';
import { PREPARE_ACTIONS } from './prepareActions';

export { PREPARE_ACTIONS };

/**
 * If any assets need Shopify format prepare, show the Prepare modal.
 * @returns {Promise<'proceed'|'cancel'|'assetCopy'>}
 */
export default async function confirmShopifyPrepareIfNeeded(assets = []) {
  const needingPrepare = filterAssetsNeedingShopifyPrepare(assets);
  if (!needingPrepare.length) {
    return PREPARE_ACTIONS.PROCEED;
  }

  const action = await showPrepareMediaForShopifyDialog({ assets: needingPrepare });

  if (action === PREPARE_ACTIONS.ASSET_COPY) {
    openAssetsCopyForShopifyPrepare(needingPrepare);
    return PREPARE_ACTIONS.ASSET_COPY;
  }

  if (action === PREPARE_ACTIONS.PROCEED) {
    return PREPARE_ACTIONS.PROCEED;
  }

  return PREPARE_ACTIONS.CANCEL;
}
